import React from 'react'
import classNames from 'classnames'

import { withStyles, Typography, WithStyles, createStyles } from '@material-ui/core'

import goldShieldIcon from './assets/gold_shield_icon.svg'
import silverShieldIcon from './assets/silver_shield_icon.svg'
import bronzeShieldIcon from './assets/bronze_shield_icon.svg'

interface Props {
  rank?: (number | null)
  size?: 'small' | 'medium' | 'large'
  className?: string
}

const styles = createStyles({
  root: {
    position: 'relative',
    display: 'inline-block',
  },
  shield: {
    display: 'block',
  },
  rank: {
    left: 0,
    width: '100%',
    textAlign: 'center',
    position: 'absolute',
  },
  smallShield: {
    width: 15,
  },
  mediumShield: {
    width: 25,
  },
  largeShield: {
    width: 35,
  },
  smallRank: {
    top: 2,
    fontSize: 9,
  },
  mediumRank: {
    top: 7,
  },
  largeRank: {
    top: 10,
    fontSize: 15,
  },
})

type InjectedProps = Props & WithStyles

const RankBadge: React.SFC<InjectedProps> = ({ rank, size, className, classes, ...props }) => {
  const parsedRank = rank! | 0 // tslint:disable-line:no-bitwise
  const parsedSize = size || 'medium'

  if (parsedRank < 1 || parsedRank > 3) {
    return null
  }

  const rankIcons: { [key: number]: string } = {
    1: goldShieldIcon,
    2: silverShieldIcon,
    3: bronzeShieldIcon,
  }

  return (
    <div {...props} className={classNames(className, classes.root)}>
      <img alt="" src={rankIcons[parsedRank]} className={classNames(classes.shield, classes[parsedSize + 'Shield'])} />
      <Typography variant="caption" className={classNames(classes.rank, classes[parsedSize + 'Rank'])}>
        {parsedRank}
      </Typography>
    </div>
  )
}

export default withStyles(styles)(RankBadge)
